var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatMenuBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 64,
    viewBox: "0 0 92 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H82C87.5229 0 92 4.47715 92 10V41.844C92 46.1232 89.2771 49.9283 85.2267 51.3091L51.0917 62.946C49.0828 63.6309 46.9081 63.6588 44.8822 63.0257L7.01725 51.1929C2.8425 49.8883 0 46.0219 0 41.6481V10Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMenuBackground);
export default __webpack_public_path__ + "static/media/chat_menu_background.cfeaf6a862cd5c2fe8813bb62efd1647.svg";
export { ForwardRef as ReactComponent };